import React, { useEffect } from "react";
import { FiChevronRight } from "react-icons/fi";
import BasketChangeQuantity from "./BasketChangeQuantity";
import { useState } from "react";
import axios from "axios";
import config from "../../../settings/config";

const ShoppingConfigs = () => {
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);
  const [minPrice, setMinPrice] = useState(null);
  const [canOrder, setCanOrder] = useState(true);

  const shopUid = window.location.pathname.split("/")[2];
  const url = config.baseUrl + `v1/shops/${shopUid}/cart-config`;

  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    `${window.location.hostname}_token`
  );

  const handleEditShoppingConfigs = async () => {
    setLoading(true);
    await axios
      .put(url, {
        min_items_count: quantity,
        min_total_price: minPrice,
        des: "",
        active_ordering: canOrder,
      })
      .then((res) => {
        setQuantity(res?.data?.min_items_count);
        setMinPrice(res?.data?.min_total_price);
        setCanOrder(res?.data?.active_ordering);
        window.history.back();
      })
      .catch((err) => console.log(err));
    setLoading(false);
  };

  const getShopConfigs = async () => {
    setLoading(true);
    await axios
      .get(url, {
        min_items_count: quantity,
        min_total_price: minPrice,
        des: "",
        active_ordering: canOrder,
      })
      .then((res) => {
        setQuantity(res?.data?.min_items_count);
        setMinPrice(res?.data?.min_total_price);
        setCanOrder(res?.data?.active_ordering);
      })
      .catch((err) => console.log(err));
    setLoading(false);
  };

  useEffect(() => {
    getShopConfigs();
  }, []);

  return (
    <div className="container-fluid">
      <section>
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "99999" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bold mb-0">ویرایش تنظیمات خرید</h1>
          </div>
          <div className="col-auto text-center align-self-center px-0">
            <button
              onClick={() => handleEditShoppingConfigs()}
              className="btn fs-6 p-0 fw-bold mb-0 color-main disabled-color"
            >
              ذخیره
            </button>
          </div>
        </header>
        <body style={{ marginTop: "80px", padding: "5%" }}>
          <div className="fs-6 fw-bold">حداقل تعداد محصولات سبد خرید</div>
          <BasketChangeQuantity
            loading={loading}
            setValue={setQuantity}
            value={quantity}
          />
          <div className="fs-6 fw-bold mt-5">حداقل قیمت محصولات سبد خرید</div>
          <input
            type="number"
            className="rounded14 border p-3 w-100 mt-3"
            min={0}
            value={minPrice}
            placeholder="تومان"
            onChange={(e) => setMinPrice(e?.target?.value)}
          />
          <div className="d-flex align-items-center justify-content-between mt-5">
            <div className="fs-6 fw-bold">پذیرش سفارش</div>
            <input
              className="form-check-input"
              style={{ width: "20px", height: "20px" }}
              checked={canOrder}
              onChange={() => setCanOrder((canOrderState) => !canOrderState)}
              type="checkbox"
            />
          </div>
        </body>
      </section>
    </div>
  );
};

export default ShoppingConfigs;
